/**
 * Load default components
 */
export { DashboardComponent } from './components/dashboard/DashboardComponent'
export { HeaderComponent } from './components/header/HeaderComponent'
export { SuccessComponent } from './components/dashboard/SuccessComponent'
export { DetailItemComponent } from './components/items/DetailItemComponent'
export { ItemShareComponent } from './components/items/ItemShareComponent'

export { PrivateRoute } from './PrivateRoute'






// WEBPACK FOOTER //
// ./src/client/LoadComponents.js